import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { HotlinesAPI } from '@etop/api/shop/hotline.api';
import { CursorPaging, Hotline } from '@etop/models';

export interface StateHotline extends EntityState<Hotline, string>, ActiveState {
  hotlineRequested: boolean;
   ui: {
      filter: HotlinesAPI.GetHotlinesFilter,
      paging: CursorPaging;
    };
}

const initialState = {
  hotlineRequested: false,
  ui: {
    filter: null,
    paging: null,
  }
};

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: 'shopHotline', resettable: true })
export class HotlineStore extends EntityStore<StateHotline> {
  constructor() {
    super(initialState);
  }
}
